<template>
  <PModal
    :open="isApplyingBulk"
    title="Gegevens worden gesynchroniseerd"
    :dismissible="false"
    :close="false"
  >
    <template #body>
      <div role="status" aria-live="polite" aria-label="Gegevens worden gesynchroniseerd">
        <p v-if="hasProgress" class="text-gray-lighten-1 text-sm select-none">
          {{ bulkProgress.processed }} van {{ bulkProgress.total }} berichten verwerkt ({{
            progressPercentage
          }}%)
        </p>
        <p v-else class="text-gray-lighten-1 text-sm select-none">Berichten worden verwerkt..</p>
        <PProgress
          :model-value="hasProgress ? bulkProgress.processed : null"
          :max="hasProgress ? bulkProgress.total : 100"
          size="sm"
          class="mt-4"
          aria-label="Gegevens worden gesynchroniseerd"
        />
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { storeToRefs } from "pinia"
import PProgress from "@/components/elements/PProgress.vue"
import PModal from "@/components/overlay/PModal.vue"
import { useSynchronisationStore } from "@/store/synchronisation.store"

const { isApplyingBulk, bulkProgress } = storeToRefs(useSynchronisationStore())

const hasProgress = computed(() => bulkProgress.value.total > 0)

const progressPercentage = computed(() => {
  if (bulkProgress.value.total === 0) {
    return 0
  }
  return Math.round((bulkProgress.value.processed / bulkProgress.value.total) * 100)
})
</script>
